import { observer } from "mobx-react";
import RmaListFiltersStore from "../../../stores/rma-list-filters-store";
import DateRangePickerV2, {IDateRangeISO} from "../../../../../../components/date-range-picker-v2/date-range-picker-v2";
import {parseIsoDateRange} from "../../../../../../utilities/timezone-utilities";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
}

const ReserverdItemsDateRangeInput: React.FC<IProps> = observer(({ rmaListFiltersStore }) => {

    /** Handle date range selection from DateRangePickerV2 */
    const onDateRangeSelect = (isoDateRange: IDateRangeISO | null) => {
        if (!isoDateRange?.from || !isoDateRange?.to) {
            rmaListFiltersStore.setReserverdItemExpirationInput(undefined);
            return;
        }

        /** Store ISO format: 2025-01-01T00:00:00Z/2025-12-31T23:59:59Z */
        rmaListFiltersStore.setReserverdItemExpirationInput(`${isoDateRange.from}/${isoDateRange.to}`);
    };

    return (
        <DateRangePickerV2
            onChange={onDateRangeSelect}
            value={parseIsoDateRange(rmaListFiltersStore.reserveItemExpirationInput, true)}
        />
    );
});

export default ReserverdItemsDateRangeInput;
